/**
 * 请求模块封装
 */
import 'whatwg-fetch';
import Cookies from 'js-cookie';
import { toLocale } from '@ok/blade';

import Page from '_common/constants/PageLink';

import Storage from './Storage';
import util from './util';

const COMMON_HEADER = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'App-Type': 'web',
  devId: util.getDeviceId(),
};

function intercept(response) {
  if (response.status >= 200 && response.status < 300) {
    const newToken = response.headers.get('x-ok-token');
    if (newToken && newToken.length !== 0) {
      localStorage.setItem('token', newToken);
      // 临时兼容ont逻辑，后续会替换本模块
      Cookies.set('isLogin', 1, { expires: 7 });
    }
    return;
  } else if (response.status === 401 || response.status === 403) {
    // 令牌无效 跳转登录
    // alert('reqAwait+' + response.config.url);
    Storage.remove('token');
    Cookies.remove('isLogin');
    // window.location.href = Page.login;
    window.location.href = `${Page.login}?logout=true&forward=${window.location.pathname}${window.location.search}${window.location.hash}`;
    return;
  }
  throw new Error(response.status);
}

/**
 * POST请求 async await 封装
 * @param url
 * @param params
 * @param {string} [token]
 * @returns {Promise<{code: *, msg: *, message: *}>}
 */
export const postAsync = async (url, params, token) => {
  const headers = COMMON_HEADER;
  headers.Authorization = token || Storage.get('token') || '';
  headers.devId = util.getDeviceId();
  const options = {
    method: 'POST',
    headers,
    body: JSON.stringify(params),
  };

  try {
    const res = await fetch(url, options);
    intercept(res);
    return await res.json();
  } catch (e) {
    return {
      code: e.message,
      msg: toLocale('serverError'),
      message: toLocale('serverError'),
    };
  }
};

/**
 * GET 请求 async await 封装
 * @param url
 * @param {Record<string, unknown>} [params]
 * @param {string} [token]
 * @returns {Promise<*>}
 */
export const getAsync = async (url, params, token) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve) => {
    const headers = COMMON_HEADER;
    headers.Authorization = token || Storage.get('token') || '';
    headers.devId = util.getDeviceId();
    // 参数解析
    let paramsStr = '';
    if (params) {
      const paramKeys = Object.keys(params);
      paramKeys.forEach((item, index) => {
        if (index === 0) {
          paramsStr += `?${item}=${params[item]}`;
        } else {
          paramsStr += `&${item}=${params[item]}`;
        }
      });
    }

    const options = {
      method: 'GET',
      headers,
      credentials: 'include',
    };
    if (navigator.userAgent.includes('OKApp')) {
      window.jsbridge
        .getToken()
        .then(async (appToken) => {
          if (appToken) {
            localStorage.setItem('token', appToken);
            options.headers.Authorization = appToken;
          }
          try {
            const res = await fetch(url + paramsStr, options);
            intercept(res);
            resolve(await res.json());
          } catch (e) {
            resolve({
              code: e.message,
              msg: toLocale('serverError'),
              message: toLocale('serverError'),
            });
          }
        })
        .catch(() => {});
    } else {
      try {
        const res = await fetch(url + paramsStr, options);
        intercept(res);
        resolve(await res.json());
      } catch (e) {
        resolve({
          code: e.message,
          msg: toLocale('serverError'),
          message: toLocale('serverError'),
        });
      }
    }
  });
};
